export default "__VITE_ASSET__CdyQ85Z$__"